export default "__VITE_ASSET__DjDKgIQr__"